import { omit } from "lodash";

import { types } from "@/actions/window";

const initialState = {
    orientation:
        window.innerHeight > window.innerWidth ? "portrait" : "landscape",
    loading: {
        active: false,
        message: "",
        type: "loading",
    },
    messages: {},
    information: "",
};

/**
 * Reducer for window state including orientation, loading overlay, and messages.
 *
 * @param state - The current window state.
 * @param root0 - The dispatched action.
 * @param root0.payload - The action payload.
 * @param root0.type - The action type.
 * @returns The next window state.
 */
export default (state = initialState, { payload, type }) => {
    switch (type) {
        case types.SET_INFORMATION:
            return { ...state, information: payload };
        case types.SET_ORIENTATION:
            return { ...state, orientation: payload };
        case types.OPEN_LOADING:
            return {
                ...state,
                loading: {
                    ...payload,
                    active: true,
                },
            };
        case types.CLOSE_LOADING:
            return { ...state, loading: initialState.loading };
        case types.SHOW_MESSAGE: {
            return {
                ...state,
                messages: {
                    ...state.messages,
                    [payload.context]: {
                        message: payload.message,
                        type: payload.type,
                    },
                },
            };
        }
        case types.HIDE_MESSAGE: {
            return {
                ...state,
                messages: omit(state.messages, payload.context),
            };
        }
        default:
            return state;
    }
};
